import VueRouter from 'vue-router'
import DOMUtils from '@/utils/DOMUtils'
import Blank from '@/views/Blank';
import Home from '@/views/Home';
import Favorites from '@/views/Favorites';
import Notifications from '@/views/Notifications';
import Actualities from '@/views/Actualities';
import ReadActuality from '@/views/ReadActuality';
import Events from '@/views/Events';
import Settings from '@/views/Settings';
import Edit from '@/views/Edit';
import EditMenuIndex from '@/views/EditMenuIndex';
import EditActualities from '@/views/EditActualities';
import EditActualitiesMenuIndex from '@/views/EditActualitiesMenuIndex';
import EditEvents from '@/views/EditEvents';
import EditNotifications from '@/views/EditNotifications';
import StoreNotifications from '@/views/StoreNotifications'
import StoreNotificationsUpgrade from '@/views/StoreNotificationsUpgrade'
import ActualityEditor from '@/views/ActualityEditor';
import EditStores from '@/views/EditStores';
import UsefulInfo from '@/views/UsefulInfo';
import Stores from '@/views/Stores'
import StorePage from '@/views/StorePage'
import LoyaltyCard from '@/views/LoyaltyCard'
import LoyaltyCardCreateAccount from '@/views/LoyaltyCardCreateAccount'
import LoyaltyCardOverview from '@/views/LoyaltyCardOverview'
import LoyaltyCardStorePage from '@/views/LoyaltyCardStorePage'
import LoyaltyCardRewardRedeemed from '@/views/LoyaltyCardRewardRedeemed'
import LoyaltyCardEdit from '@/views/LoyaltyCardEdit'
import LoyaltyCardEditScan from '@/views/LoyaltyCardEditScan'
import LoyaltyCardEditScanManual from '@/views/LoyaltyCardEditScanManual'
import LoyaltyCardEditCreditPoints from '@/views/LoyaltyCardEditCreditPoints'
import LoyaltyCardEditRewards from '@/views/LoyaltyCardEditRewards'
import LoyaltyCardEditHistory from '@/views/LoyaltyCardEditHistory'
import LostObjects from '@/views/LostObjects'
import Covid from '@/views/Covid'
import NewCovidCertificate from '@/views/NewCovidCertificate'
import GenerateCovidCertificate from '@/views/GenerateCovidCertificate'
import SettingsIndex from '@/views/SettingsIndex'
import StoreEditor from '@/views/StoreEditor'
import LoginForm from '@/views/LoginForm'
import LogoutForm from '@/views/LogoutForm'
import Devtools from '@/views/Devtools'
import Report from '@/views/Report'
import AccountsManagement from '@/views/AccountsManagement'
import CreateAdminAccount from '@/views/CreateAdminAccount'
import ReportsManagement from '@/views/ReportsManagement'
import EditUsefulInfo from '@/views/EditUsefulInfo'
import LostObjectsManagement from '@/views/LostObjectsManagement'
import LostPetsManagement from '@/views/LostPetsManagement'
import Offline from '@/views/Offline'
import FatalError from '@/views/FatalError'
import Theme from '@/views/Theme'
import About from '@/views/About'
import NotificationSettings from '@/views/NotificationSettings'
import Account from '@/views/Account'
import Splashscreen from '@/views/Splashscreen'
import DisplayThemePalette from '@/views/DisplayThemePalette'
import LostPets from '@/views/LostPets'
import LoyaltyCardEditCustomers from '@/views/LoyaltyCardEditCustomers'

function hideMainMenuIfNotDesktop ()
{
    return { hideMainMenu: DOMUtils.reactives.currentMediaName == 'desktop' ? false : true }
}

const routes =
[
    { path: '/', component: Home, name: 'Index' },
    { path: '/home', component: Home, name: 'Home' },
    { path: '/blank', component: Blank },
    { path: '/favorites', component: Favorites, name: 'Favorites' },
    { path: '/notifications', component: Notifications, name: 'Notifications' },
    {
        path: '/settings', component: Settings, children:
        [
            { path:'/', component: SettingsIndex },
            { path: 'login', component: LoginForm, name: 'Login', props: true },
            { path: 'logout', component: LogoutForm, name: 'Logout' },
            { path: 'accounts/:id', component: Account, name: 'Account', meta: {viewTitle: 'Mon Compte'} },
            { path: 'theme', component: Theme, name: 'Theme', meta: {viewTitle: 'Apparence'} },
            { path: 'about', component: About, name: 'About', meta: {viewTitle: 'À propos'} },
            { path: 'notifications', component: NotificationSettings, name: 'NotificationSettings', meta: {viewTitle: 'Notifications'} },
            { path: 'devtools', component: Devtools, name: 'Devtools' },
        ]
    },
    { path: '/edit', component: Edit, children:
        [
            { path: '/', component: EditMenuIndex },
            {
                path: 'actualities', component: EditActualities, children:
                [
                    { path: '/', component: EditActualitiesMenuIndex, name: 'EditActualitiesMenuIndex' },
                    { path: 'add', component: ActualityEditor, name: 'ActualityEditorAdd', meta: { dynamic: hideMainMenuIfNotDesktop } },
                    { 
                        path: 'edit/:id',
                        component: ActualityEditor,
                        name: 'ActualityEditorEdit',
                        meta: { dynamic: hideMainMenuIfNotDesktop },
                        props: route => ({ template: Number.parseInt(route.params.id) })
                    }
                ]
            },
            { path: 'events', component: EditEvents, name: 'EditEvents' },
            { 
                path: 'reports', component: ReportsManagement, name: 'ReportsManagement', children:
                [
                    // in-component routing
                    { path: '*', component: Blank },
                ]
            },
            { path: 'useful-info', component: EditUsefulInfo, name: 'EditUsefulInfo' },
            { path: 'accounts', component: AccountsManagement, name: 'AccountsManagement' },
            { path: 'accounts/create', component: CreateAdminAccount, name: 'CreateAdminAccount' },
            { path: 'notifications', component: EditNotifications, name: 'EditNotifications' },
            { path: 'store-notifications/:id', component: StoreNotifications, name: 'StoreNotifications' },
            { path: 'store-notifications/:id/upgrade', component: StoreNotificationsUpgrade, name: 'StoreNotificationsUpgrade' },
            { path: 'stores', component: EditStores, name: 'EditStores' },
            { path: 'stores/add', component: StoreEditor, name: 'StoreEditorAdd', meta: { dynamic: hideMainMenuIfNotDesktop } },
            { path: 'stores/update/:id', component: StoreEditor, name: 'StoreEditorUpdate', meta: { dynamic: hideMainMenuIfNotDesktop } },
            { 
                path: 'lost-objects', component: LostObjectsManagement, name: 'LostObjectsManagement', children:
                [
                    // in-component routing
                    { path: '*', component: Blank },
                ]
            },
            { 
                path: 'lost-pets', component: LostPetsManagement, name: 'LostPetsManagement', children:
                [
                    // in-component routing
                    { path: '*', component: Blank },
                ]
            },
            { path: 'loyalty-card/:storeId', component: LoyaltyCardEdit, name: 'LoyaltyCardEdit' },
            { path: 'loyalty-card/:storeId/scan', component: LoyaltyCardEditScan, name: 'LoyaltyCardEditScan' },
            { path: 'loyalty-card/:storeId/scan/manual', component: LoyaltyCardEditScanManual, name: 'LoyaltyCardEditScanManual' },
            { path: 'loyalty-card/:storeId/credit-points/:cardId', component: LoyaltyCardEditCreditPoints, name: 'LoyaltyCardEditCreditPoints' },
            { path: 'loyalty-card/:storeId/rewards', component: LoyaltyCardEditRewards, name: 'LoyaltyCardEditRewards' },
            { path: 'loyalty-card/:storeId/history', component: LoyaltyCardEditHistory, name: 'LoyaltyCardEditHistory' },
            { path: 'loyalty-card/:storeId/customers', component: LoyaltyCardEditCustomers, name: 'LoyaltyCardEditCustomers' },
        ]
    },
    { path: '/actualities', component: Actualities, name: 'Actualities' },
    { path: '/actualities/:id', component: ReadActuality, name: 'ReadActuality', meta: { hideMainMenu: true } },
    { path: '/events', component: Events, name: 'Events',},
    { path: '/report', component: Report, name: 'Report',},
    { path: '/useful-info', component: UsefulInfo, name: 'UsefulInfo',},
    { path: '/stores', component: Stores, name: 'Stores',},
    { path: '/stores/:id', component: StorePage, name: 'StorePage', meta: { hideMainMenu: true } },
    { path: '/loyalty-card', component: LoyaltyCard, name: 'LoyaltyCard', children:
        [
            { path: 'create-account', component: LoyaltyCardCreateAccount, name: 'LoyaltyCardCreateAccount' },
            { path: 'overview', component: LoyaltyCardOverview, name: 'LoyaltyCardOverview' },
            { path: 'store/:storeId', component: LoyaltyCardStorePage, name: 'LoyaltyCardStorePage' },
            { path: 'store/:storeId/redeemed/:rewardId', component: LoyaltyCardRewardRedeemed, name: 'LoyaltyCardRewardRedeemed' },
        ]
    },
    { path: '/lost-objects', component: LostObjects, name: 'LostObjects',},
    { path: '/lost-pets', component: LostPets, name: 'LostPets',},
    { path: '/covid', component: Covid, name: 'Covid',},
    { path: '/covid/certificates/new', component: NewCovidCertificate, name: 'NewCovidCertificate',},
    { path: '/covid/certificates/generate', component: GenerateCovidCertificate, name: 'GenerateCovidCertificate',},
    { path: '/offline', component: Offline, name: 'Offline', meta: { hideMainMenu: true, hideStatusBar: true } },
    { path: '/fatal-error', component: FatalError, name: 'FatalError', meta: { hideMainMenu: true, hideStatusBar: true } },
    { path: '/splashscreen', component: Splashscreen, name: 'Splashscreen', meta: { hideMainMenu: true, hideStatusBar: true } },
    { path: '/display-theme-palette', component: DisplayThemePalette, name: 'DisplayThemePalette', meta: { hideMainMenu: true, hideStatusBar: true } },
]

const router = new VueRouter
({
    routes,
})

router.beforeEach((to, from, next) =>
{
    const dynamicMetaFn = to.meta.dynamic;
    if (!dynamicMetaFn) return next()

    if (typeof dynamicMetaFn !== 'function')
    {
        console.error(`Dynamic meta for ${to} coming from ${from} needs to be of 'function' type and not ${typeof dynamicMetaFn}`)
        
        return next()
    }

    Object.assign(to.meta, dynamicMetaFn(to, from))

    next()
});

const originalPush = router.push
router.push = function push(location, onResolve, onReject)
{
    if (onResolve || onReject)
    {
        return originalPush.call(this, location, onResolve, onReject)
    }
 
    return originalPush.call(this, location).catch((err) =>
    {
        if (VueRouter.isNavigationFailure(err))
        {
            return err
        }
   
        return Promise.reject(err)
    })
}

export default router


// WEBPACK FOOTER //
// ./src/router.js